
<template>
  <div :class="{'has-logo':showLogo}">
    <logo v-if="showLogo" :collapse="isCollapse" />
    <el-scrollbar wrap-class="scrollbar-wrapper">
      <el-menu
        :default-active="activeMenu"
        :collapse="isCollapse"
        :background-color="variables.menuBg"
        :text-color="variables.menuText"
        :unique-opened="true"
        :active-text-color="variables.menuActiveText"
        :collapse-transition="false"
        mode="vertical"
      >
        <sidebar-item
          v-for="route in new_permission_routes"
          :key="route.path"
          :item="route"
          :base-path="route.path"
        />
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Logo from './Logo'
import SidebarItem from './SidebarItem'
import variables from '@/styles/variables.scss'
import { deepClone, parseTime } from '@/utils'
export default {
  components: { SidebarItem, Logo },
  data() {
    return {
    }
  },
  computed: {
    ...mapGetters(['permission_routes', 'sidebar', 'userModule']),
    /**
     * 过滤路由
     * @returns {*}
     */
    new_permission_routes() {
      // console.log('permission_routes', this.permission_routes)
      const route = this.$route
      let list = []
      // console.log(route.matched)
      let path = route.matched[0].path
      path === '' ? path = '/' : '' // 处理首页的问题
      // console.log('当前根路由:' + path)

      // 本地测试环境
      // if (process.env.NODE_ENV === 'development') {
      //   return this.permission_routes.filter(item => {
      //     return item.path === path
      //   })
      // }

      list = this.permission_routes.filter(item => {
        return item.path === path
      })

      // list = this.userModule.filter(item => {
      //   return item.path === path
      // })
      // // 如果返回的数据没有数据，就从本地路由查找
      // if (list.length === 0) {
      //   list = this.permission_routes.filter(item => {
      //     return item.path === path
      //   })
      // }
      if (list.length > 0) {
        return list[0].children
      } else {
        return []
      }
    },
    activeMenu() {
      const route = this.$route
      const { meta, path } = route
      // if set path, the sidebar will highlight the path you set
      if (meta.activeMenu) {
        return meta.activeMenu
      }
      return path
    },
    showLogo() {
      return this.$store.state.settings.sidebarLogo
    },
    variables() {
      return variables
    },
    isCollapse() {
      return !this.sidebar.opened
    }
  },
  mounted() {
    // console.log(parseTime(3600*1000, '{h}:{i}'))
    // console.log(this.permission_routes)
  }
}
</script>
